<template>
  <div class="page-content">
    <el-table
        ref=""
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
          <el-table-column
          prop="productKey"
          label="productKey">
        </el-table-column>
          <el-table-column
          prop="deviceName"
          label="deviceName">
        </el-table-column>
          <el-table-column
          prop="ip"
          label="ip地址">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="时间">
        </el-table-column>
        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <div>
              {{scope.row.statuesType === 0 ?'上线':'下线'}}
            </div>
          </template>
        </el-table-column>
      </el-table>
    <el-row class="footer" :span="24">
          <el-col :span="24">
            <el-row :span="24" class="dataListOperation" justify="end" type="flex">
              <el-col :span="12" >
                <el-row :span="24" type="flex" justify="end">
                  <div class="showAll"> 共<span>{{pageParams.total}}</span>条数据</div>
                  <el-pagination
                    layout="prev, pager, next"
                    @current-change="currentChange"
                    :page-size="pageParams.pageSize"
                    :total="pageParams.total">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
  </div>
</template>
<script>
import { logProductStatusList } from '@/api/log'
import { eventBus } from '@/utils/eventBus'
export default {
  props: {
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    }
  },
  data () {
    return {
      pageParams: {
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      tableData: []
    }
  },
  methods: {
    getLogProductStatusList (searchParams) {
      if (!this.productKey) {
        return
      }
      let params
      if (searchParams) {
        this.pageParams.pageNumber = 1
        params = Object.assign({ productKey: this.productKey }, searchParams)
      } else {
        let Obj = {}
        if (this.deviceName) {
          Obj = {
            deviceName: this.deviceName
          }
        }
        params = Object.assign({ productKey: this.productKey }, Obj, this.pageParams)
      }
      logProductStatusList(params).then(res => {
        res = res.data
        console.log('获取的上下线数据：', res)
        this.pageParams.total = res.data.total
        this.tableData = res.data.LogDeviceStatus
      })
    },
    currentChange (val) {
      this.pageParams.pageNumber = val
      this.getLogProductStatusList()
    }
  },
  created () {
    this.getLogProductStatusList()
    const that = this
    eventBus.$on('search-online-log', (params) => {
      console.log('search-online-log:', params)
      that.getLogProductStatusList(params)
    })
  },
  watch: {
    productKey () {
      console.log('变化了')
      this.getLogProductStatusList()
    }
  }
}
</script>
<style lang="less" scope>
.page-content{
  .footer{
      padding: 20px 10px ;
    }
  .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
}
</style>
